import LiveCallWidget from "./call-widget.gjs";
import LiveVoiceCanvas from "./voice-canvas.gjs";

export default <template>
  <LiveVoiceCanvas />
  <LiveCallWidget />
</template>
